<template>
  <div class="main">
    <titleBox v-if="pageId == 2" name="加入旷真" imgUrl="../../assets/about/title.png"></titleBox>
    <div v-if="pageId == 1" class='maxWidth'>
      <div v-html="content"></div>
    </div>
    <div v-if="pageId == 2" class="set-main-style">
      <div class="set-main-one">
        <h2 class="titleBox">
          <img
            src="https://kz-images.oss-cn-shenzhen.aliyuncs.com/kzweb/Mobile/numberImg/01.png"
            class="numberImg"
            alt=""
          />
          {{talentObj1.title}}
          <i class="redIcon"></i>
        </h2>
        <!-- <div class="set-one">{{talentObj1.title}}</div> -->
        <div v-for="item in talentObj1.List" class="set-one-item">
          <div class="set-one-item-title" :style="`width: ${item.titleWidth}rem`">
            <img
              :src="item.img"
              alt=""
            />
            <div>{{item.name}}</div>
          </div>
          <div class="set-one-item-content">
            {{item.describe1}}
          </div>
          <div class="set-one-item-content">
            {{item.describe2}}
          </div>
        </div>
      </div>
      <div class="set-main-two set-bg">
        <h2 class="titleBox">
          <img
            src="https://kz-images.oss-cn-shenzhen.aliyuncs.com/kzweb/Mobile/numberImg/02.png"
            class="numberImg"
            alt=""
          />
          {{talentObj2.title}}
          <i class="redIcon"></i>
        </h2>
        <!-- <div class="set-two">{{talentObj2.title}}</div> -->
        <div v-for="item in talentObj2.List" class="set-two-item">
          <div class="set-two-item-content">
            {{item}}
          </div>
        </div>
      </div>
      <div class="set-main-three">
        <!-- <div class="set-three">{{talentObj3.title}}</div> -->
        <h2 class="titleBox">
          <img
            src="https://kz-images.oss-cn-shenzhen.aliyuncs.com/kzweb/Mobile/numberImg/03.png"
            class="numberImg"
            alt=""
          />
          {{talentObj3.title}}
          <i class="redIcon"></i>
        </h2>
        <div v-for="(item, index) in talentObj3.List" class="set-width-style">
          <div class="set-three-item">
            <div class="set-three-item-left">
              <img
                :src="item.img"
                alt=""
              />
            </div>
            <div class="set-three-item-right">
              <div class="set-three-item-right-title">
                <span class="set-three-item-right-name">{{item.name}}</span>
                <span class="set-three-item-right-entry">丨{{item.entry}}</span>
              </div>
              <div class="set-three-item-right-content">{{item.describe1}}</div>
            </div>
          </div>
          <div>
            <div class="set-three-item-footer" v-if="index+1 != talentObj3.List.length"></div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import req from "../../utils/index";
import titleBox from "@/components/titleBox";
export default {
  components: { titleBox },
  data() {
    return {
      content: "",
      pageId: "",
      talentObj1: {
        title: "在旷真，人才的发展从来都不止一条路径",
        List: [
          {
            img: "https://kz-images.oss-cn-shenzhen.aliyuncs.com/kzweb/pc/talentGrowth/talentGrowth-01-01.png",
            name: "岗位的发展",
            titleWidth: "3",
            describe1: "首先可以是岗位的发展。旷真精益模式追求的精髓，在于把法律服务的过程进行分工，让每个岗位都有标准化的专业作业要求。我们鼓励律师在有能力，且有“接班人”的情况下，进行岗位的转换。比如你原本在诉讼律师岗位，你想更多地提升自己客户面的能力，就可以申请岗位的横向转换，从生产端岗位，到销售端岗位。",
            describe2: "同时，旷真作为一家专业服务机构，一定是管理者和专家的合伙，各司其职。管理者做好目标管理、人员管理、资源管理等，专家做好重大案件、重要客户、业务赋能等。所以，岗位的发展，也可以是管理者和专家岗位的横向转换。"
          },
          {
            img: "https://kz-images.oss-cn-shenzhen.aliyuncs.com/kzweb/pc/talentGrowth/talentGrowth-01-02.png",
            name: "业务拓展的发展",
            titleWidth: "5",
            describe1: "其次是业务拓展的发展。花无百日红，久利不可增，旷真绝不可能只靠一个产品、一个业务，来保持长期高速增长。因此随着律所内部法律产品的不断研发、我们业务面不断拓展，律师就算只在同一个岗位上，也能逐渐接触到不同的业务，比如我们要求诉讼律师一主二辅。",
          },
          {
            img: "https://kz-images.oss-cn-shenzhen.aliyuncs.com/kzweb/pc/talentGrowth/talentGrowth-01-03.png",
            name: "职级的发展",
            titleWidth: "4",
            describe1: "最后是职级的发展。旷真的职级发展可以从10级的协办律师一直到19级的高级律师，同时管理岗和专业岗也根据不同的职级划分了相应的职称，比如专业岗上14级的诉讼律师，再往上走就可以是15级的资深诉讼律师，或者更高级别的诉讼条线专家。"
          }
        ]
      },
      talentObj2: {
        title: "旷真大学，关注你的每一步成长",
        List: [
          "在旷真，针对人才培养，我们专门设立了旷真大学，它是旷真的人才培训基地，也是旷真内优外拓战略实施的助推器。",
          "旷真推崇培养人是从知识、技能、能力、价值观（KSAV）来的。知识分成行业知识和法律知识，通过乐享平台让大家自学考试；技能主要分成技术技能和顾问技能，通过训战结合方式来在实战中练习；能力是通过能力认证，给每个岗位定详细的能力标准和材料要求，员工准备好就来答辩，通过乐享直播给全员来观摩、监督、学习。",
          "2024年，旷真各岗位能力认证通过人数总计353人。",
          "旷真通过能力认证这项制度，把律师的能力发展纳入了转正、晋升的重要指标。通俗来说就是，我们总结了出一套评估标准，明确了每个岗位所需要的能力范畴，并不断更新迭代。只有通过能力认证这把“梯子”的律师，才能在旷真“升职加薪、迎娶白富美、走上人生巅峰”。",
          "当然，我们也根据这套评估标准，匹配了相应的学习提升路径，然后通过能力认证，来对齐律师的各项能力标准，从认识差距到补足差距，不断提升律师的专业度。",
        ]
      },
      talentObj3: {
        title: "旷真90后首席律师，也是未来的你",
        List: [
          {
            img: "https://kz-images.oss-cn-shenzhen.aliyuncs.com/kzweb/pc/talentGrowth/talentGrowth-03-01.png",
            name: "张思思律师",
            entry: "2015年入职",
            describe1: "刚毕业进入旷真的两年，我是高歌猛进地入场，有了在广州市场开拓“打胜仗”的经历，我一路从律师助理做到了首席律师。旷真快速发展离不开组织的壮大，这也会不断涌现出一些机会，把律师“推”上管理岗位。我成为首席也是“跑步上岗”的，但是当“打胜仗”已然成了我的习惯思维时，我在旷真的“管理”之路，也展开得格外顺利。"
          },
          {
            img: "https://kz-images.oss-cn-shenzhen.aliyuncs.com/kzweb/pc/talentGrowth/talentGrowth-03-02.png",
            name: "刘甜律师",
            entry: "2018年入职",
            describe1: "青年律师最大的优势就是充满干劲和时间充裕，我们有大量的时间通过学习和研究提升自己的能力。专业化发展是大势所驱，毕业时的我，希望把有限的时间花在最有用的地方，通过学习了解一个行业，在旷真建立完整、系统的思维方式。经过这几年的历练后，我更加认为，这一条路是对的。"
          },
          {
            img: "https://kz-images.oss-cn-shenzhen.aliyuncs.com/kzweb/pc/talentGrowth/talentGrowth-03-03-01.png",
            name: "贾天赐律师",
            entry: "2019年入职",
            describe1: "如果说在旷真的前六年，我更多的是追求个人的成长，一步步闯关，一步步提升，那接下来，我更想和团队的伙伴一起并肩前行。挖掘到比我更优秀的伙伴加入到团队中，共同做大蛋糕，实现个人、团队以及组织的复利。至于长期规划，我相信，只要走好眼前的每一步，一切都会水到渠成。或许未来的某天，我会到达一个旷真未曾涉足的市场，从0开始搭建一个新的团队、一家分所……在旷真，挑战永远存在，但我知道，只要牢记着来时的每一步，我的路，会一步比一步踏实稳健。"
          },
          {
            img: "https://kz-images.oss-cn-shenzhen.aliyuncs.com/kzweb/pc/talentGrowth/talentGrowth-03-04.png",
            name: "万宇律师",
            entry: "2021年入职",
            describe1: "当我开始寻找新的律所时，考虑了三个问题:律所专业领域是否足够深，是否有足够多的案件数量；对青年律师是否友好，有没有向上发展空间;团队的人员氛围、办公环境是否能让人愉悦。综合考虑这些因素后，我选择加入旷真，从一开始在应收款事业成功开拓新市场，到如今做到了首席律师，实现了自己职业生涯的快速飞跃。"
          }
        ]
      }
    };
  },
  created() {
    // console.log(this.$route.query);
    this.pageId = this.$route.query.id;
    let guid =
      this.$route.query.id == 2
        ? "499a0efd-00f7-11ed-a83e-7486e20da009"
        : "30c3017c-00f7-11ed-a83e-7486e20da009";
    // req("get", "api/base/getcontentII?guid=" + guid, {}).then((res) => {
    //   //   console.log(res);
    //   this.initeData(res.info);
    // });
    if (this.pageId == 1) {
      this.initeData({
        content:
          '<div class="la-msg">	<img src="https://f.kzspp.com/cms/new/theme/kz/img/onelt.webp" alt="" class="center-block"> 	<h2 class="la-color-R text-center">		致未来旷真人的一封信	</h2>	<div class="la-textMsg">		各位未来的旷真合伙人：<br><br>	</div>	<div class="la-textMsg">		这封信，我们来聊聊 <strong>律师如何在当前中国空前绝后的法律服务市场中抓住机遇</strong> ，这个话题看起来很大，但是事关我们每个法律人的利益。	</div>	<div class="la-textMsg">		<br>		<div style="text-align:center;">			<strong>为什么说目前中国的法律市场是空前绝后的？</strong> 		</div><br>按照人类社会发展的一般规律，转型期往往伴随着矛盾的产生，矛盾催生法律需求。<br><br>中国人口基数大，且正处在社会转型的关键期，矛盾多发，法律服务市场空前巨大。而中国又是一个单一制国家，实行单一制法律制度，这就保证了中央政令能够全国通行，为法律服务全国化提供了便利。<br><br>但是中国目前法律市场也存在很大的供需矛盾，每年有大量的年轻律师进入法律服务市场，却苦于找不到案源，而很多法律需求量大、对法律服务专业化要求较高的行业又没有足够的专业律师提供服务。<br><br>法律服务行业亟待供给侧改革，通过改革供给端的结构，解决供需错位导致的矛盾，增加有效供给，而这场改革对于我们来说恰恰意味着机遇。<br><br>		<div style="text-align:center;">			<strong>那我们怎样在法律服务供给侧改革中抓住机遇？</strong> 		</div><br>我们都知道，我国目前正在大力推进新型城镇化，城镇化已经成为推动我国经济、社会发展的强大引擎，而城镇化进程的推进带动了建筑建材行业的发展，建筑建材行业的发展又催生出巨大的法律服务市场，但国内专注于建筑建材行业，能够满足这个行业需求的律所少之又少。<br><br>而旷真在这场法律服务供给侧改革中抓住了机遇，进入了发展的快车道。<br><br>2009年我创办了旷真律师事务所，到现在已经8个年头，旷真从一个创立初期只有几个人的微型律所，发展到现在拥有300名员工，在广州、深圳、成都、重庆、济南、珠海、乌鲁木齐等地设立分支机构的全国性律师事务所，成为建材行业法律服务的领航者。<br><br>这一过程并不是一帆风顺的，我们也走过很多的弯路，交了很多学费，总结起来，旷真通过以下三步抓住了这个机遇：<br><br><strong>第一步，做乘法，找到增值模式，把工匠式的法律服务变成有稳定市场的可增值产品</strong><br><br>我之前有个客户，是做危险化学品物流的，从最开始只有两三百万的资金规模，三年不到就赚到了一个亿。这个对我的触动很大，我就想，他是怎么做到的？为什么法律服务行业累死累活都做不到？<br><br>后来我发现了其中的道理，原来他卖的是有具体市场的产品，而且采用了免费增值模式，我又发现市面上做成功的企业都有明确的市场，针对具体的市场打造符合市场需求的产品，而且很多都采用免费增值的模式。而传统的法律服务其实是没有市场的，都是市场恰恰意味着没有市场，什么领域都做，什么案子都接，就做不精，没有针对性的服务产品，没有建立起自己的一套商业增值模式，不能吃透一个行业领域，也就做不到利润最大化。<br><br>所以，旷真决定做乘法，针对建材行业建材供应商应收账款回收难的痛点设计法律服务产品，通过产品化、标准化、流程化提供精益法律服务，改变过去传统工匠式法律服务个体运作，缺乏标准，无法形成规模化的弊端。旷真还创新性地提出“先服务后收费”的全风险代理模式，实现了商业增值。 <br><br><strong>第二步，做减法，找准市场，专注投入，打造核心竞争力</strong><br><br>做乘法实现增值这个好理解，那怎么理解做减法呢？是要减什么呢？<br><br>我们都知道传统律师的服务领域和对象很多很杂，一个律师可能既做刑事又做民事，既做婚姻又做交通，就很难做到专而精；传统律师办案通常是自己一个人完成的，从找案源、接待客户、调查取证、出庭辩论等都需亲自上场，很大程度上限制了律师才能的发挥；另外传统律师服务收费又多又杂，咨询顾问费、代书文书费、诉讼代理费等等，基本上是做一件事就收一次费，客户体验不好。<br><br>而旷真就做减法，在<strong>服务领域</strong>上，旷真精准定位于特定行业-建材行业中的混凝土、钢材、架管三个品类，目前推出的成熟产品-建材应收账款风险管理只服务于建材供应商，旷真专注这个领域，把这个领域摸透，在这个基础上把服务打造成标准化、流程化的产品，然后再进入下一个领域，去研究、设计、开发、生产下一个产品。<br><br>在<strong>律师办案</strong>上，旷真利用人才杠杆原理，通过团队的分工与协作，初级律师与资深律师搭配，非律师团队支持律师团队，开拓顾问团队、客户律师团队、交付律师团队协同作战，提高了团队的整体效能。这种模式下，初级律师不用为了案源而烦恼，资深律师不会被繁琐的流程所累。<br><br>在<strong>客户体验</strong>上，旷真以客户为中心，把传统法律服务中的那些杂七杂八的费用统统砍掉，采取前面提到的“先服务后收费”的全风险代理模式，先行垫资与客户共担风险，形成风雨同舟的利益共同体，客户的利益就是我们的利益。这样旷真律师就不是被动地听从客户的指令，而是主动地去帮助客户解决问题，赢得了客户的尊重。<br><br><strong>第三步，理性扩张，通过跨地域和做团队，建立集团化管控模式</strong><br><br>有了精准的定位，高效的团队协作机制，契合市场痛点的增值模式和服务产品，旷真就开始考虑全国化扩张，去复制我们的经验优势。<br><br>前面提到，城镇化进程推进了建筑建材行业的发展，建筑建材行业的发展又催生出巨大的法律服务市场。那么哪里基建、城建工程市场大，建筑建材行业应收账款多，哪里就是旷真的目标。<br><br>2012年，旷真带着紧迫感，迈出了全国化扩张第一步-重庆。我们当时什么都没有，谁都不认识，基于对于趋势的判断和城镇化催生建设需求，建设需求必然产生建筑类合同纠纷的判断就去了，重庆当时是符合这个判断的。<br><br>在集团化、全国化扩张过程中，经过一系列的经验代价，旷真的团队管理也开始找到平衡点。<br><br>旷真虽然实现了集团化，但本质上还是个创业团队，创业团队在创业初期最大的问题就是组织运作不规范，没有制度。后来旷真通过管理制度化构建起了一个强而有力、高效规范的职能支持业务，总部支持地方的组织架构。旷真追求用组织的力量、功能的积聚来实现规模化和效益最大化。<br><br>吸引、发展、保留和安排员工是律所成败的决定性因素。旷真的团队管理有三大工具：业绩表，组织架构，价值账户。组织架构是核心，组织架构搭建起来了，我们开始通过业绩表和价值账户来解决人才管理的问题。<br><br>业绩表的作用在于让员工通过对上月工作进行总结、对下月工作提出计划，去发现问题，再有针对性地去解决问题，明确目标，并有计划地去实现目标；价值账户中每个员工都相当于自己公司的经营者，价值账户就是名下公司的利润表和资产负债表，员工通过价值账户的核算了解自己工作的“经营情况”，再去调整经营策略。<br><br>在旷真，有一个“旷真MIC”——“旷真百万年薪俱乐部”。旷真的业务模式、人才培养机制让人才能在较短的时间内实现经验积累和能力提升，已经有不少年轻律师通过自己的努力实现了年薪百万，比如广州分所主任张斌。<br><br>旷真能够让律师赚到钱，获得能力成长和地位上的提升，更有安全感，更有信心，更有力量。<br><br>		<div style="text-align:center;">			<strong>大变局下，你是迎接改变还是等待被改变？</strong> 		</div><br>不破不立，格物致知。<br><br>旷真一直在破坏传统法律服务模式，而我认为这种破坏恰恰是对律师群体的一种提升。面对全新格局，如果我们不去改变，不去创新，一味原地等待，那就只有被改变的结果。<br><br>我们坚信——预测未来的最好方式就是创造未来。<strong>未来有无数种可能性，跟上行业发展步伐的最好方法是加入改变行业的队伍，一起创造未来。</strong><br><br>客户中心、价值创造、魅力品质、团队合力、持续学习、本真求是、开拓进取是旷真的七大价值观。<br><br>旷与真，本就意味着包容与偏见，在这多元的时代，企业或许是最后几个能塑造价值观的社团。我们希望有更多志同道合，认同旷真的价值观，认同旷真模式的人才加入旷真，加入到“旷真MIC”。<br><br>如果你认同我们的价值观，渴望突破和改变，欢迎你加入我们！<br><br>		<div style="text-align:right;">			罗迎朝		</div><br><br><br><br></div></div>',
      });
    } else if (this.pageId == 2) {
      this.initeData({
        content:
          '<img src="https://f.kzspp.com/cms/new/theme/kz/img/rencai01.png" width="100%">',
      });
    }
  },
  methods: {
    initeData(data) {
      let nodes = data.content;
      const regex = new RegExp("<img", "gi");
      const space = new RegExp("<p>&crarr;</p>", "gi");
      const space1 = new RegExp("section", "gi");
      const space2 = new RegExp("<p", "gi");
      const space3 = new RegExp("↵", "gi");
      const space4 = new RegExp('<div class="la-textMsg"', "gi");
      const space5 = new RegExp('<h2 class="la-color-R text-center"', "gi");

      nodes = nodes.replace(regex, `<img style="width: 100% ;"`);
      nodes = nodes.replace(space, "");
      nodes = nodes.replace(space1, "p");
      nodes = nodes.replace(space2, `<p style="margin-top:15px"`);
      nodes = nodes.replace(space3, "");
      nodes = nodes.replace(
        space4,
        "<div class='la-textMsg' style='line-height: 0.8rem;color: #979797;padding: 0 0.8rem;font-size: 0.4rem'"
      );
      nodes = nodes.replace(
        space5,
        '<h2 class="la-color-R text-center" style="color: rgb(198,0,18);text-align: center;font-size: 0.8rem"'
      );
      this.content = nodes;
    },
  },
};
</script>

<style lang="scss" scoped>
.maxWidth {
  position: relative;
  margin-top: 1.5rem;
  box-shadow: 0.1rem 0.2rem 1rem rgb(193, 193, 193);
}
.redIcon {
  position: relative;
  display: inline-block;
  top: -0.3rem;
  width: 8px;
  height: 7px;
  background-size: 100% 100%;
  background-image: url(http://kz-images.oss-cn-shenzhen.aliyuncs.com/kzweb/Mobile/redIcon.png);
}
.set-bg {
  background-image: url(https://kz-images.oss-cn-shenzhen.aliyuncs.com/kzweb/Mobile/numberImg/marriage-01-BG.png);
  background-repeat: repeat-x;
  background-position: center bottom; /* 确保背景图在底部居中 */
}
.set-main-style {
  margin: auto;
  background-color: #fff;
  // padding: 0 0.8rem;
  .set-width-style {
    width: 94%;
    margin: auto;
  }
  .set-main-one, .set-main-two, .set-main-three {
    padding-top: 0.6rem;
    padding-bottom: 0.6rem;
    .titleBox {
      width: 94%;
      margin: auto;
      padding-top: 0.5rem;
      margin-bottom: 0.2rem;
      position: relative;
      height: 1rem;
      line-height: 1rem;
      font-size: 0.4rem;

      .numberImg {
        position: relative;
        top: 0.05rem;
        width: 0.42rem;
        height: 0.42rem;
      }
    }
    .set-one, .set-two, .set-three {
      color: #333333;
      font-size: 0.4rem;
      font-weight: bold;
      margin-bottom: 0.5rem;
    }
    .set-one-item, .set-two-item {
      width: 87%;
      margin: 0 auto;
      box-sizing: border-box;
      padding-left: 0.2rem;
      line-height: 0.6rem;
      font-size: 0.35rem;
      font-family: PingFangSC-Regular, PingFang SC;
      color: #666666;
      .set-one-item-title {
          font-size: 0.4rem;
          color: #fff;
          display: flex;
          background: #C8050F;
          border-radius: 0.3rem;
          padding: 0.2rem 0.2rem;
          font-weight: bold;
          margin-bottom: 0.3rem;
          line-height: 0.4rem;
        img {
          width: 0.4rem;
          height: 0.4rem;
          padding-right: 0.2rem;
        }
      }
      .set-one-item-content, .set-two-item-content {
        font-size: 0.35rem;
        color: #666666;
        line-height: 0.9rem;
        margin-bottom: 0.5rem;
        text-align: justify;
        text-justify: inter-word; /* 或者 text-justify: distribute-all-lines; */
      }
    }
    .set-three-item {
      margin-bottom: 0.5rem;
      margin-top: 0.5rem;
      display: flex;
      justify-content: space-between;
      .set-three-item-left {
        width: 22%;
        img {
          width: 100%;
        }
      }
      .set-three-item-right {
        width: 75%;
        .set-three-item-right-title {
          margin: 0.2rem 0;
          .set-three-item-right-name {
            color: #333333;
            font-weight: bold;
            font-size: 0.4rem;
          }
          .set-three-item-right-entry {
            color: #333333;
            font-size: 0.4rem;
          }
        }
        .set-three-item-right-content {
          line-height: 0.5rem;
          font-size: 0.3rem;
          color: #333333;
          text-align: justify;
          text-justify: inter-word; /* 或者 text-justify: distribute-all-lines; */
        }
      }
    }
    .set-three-item-footer {
      background: repeating-linear-gradient(to right, #CCCCCC, #CCCCCC 5px, transparent 5px, transparent 10px);
      height: 2px; /* 设置元素高度为1px */
      width: 100%; /* 设置元素宽度为100% */
    }
  }
}
</style>
